import apiManager  from './components/api-manager';
import { isAFunction } from './global/utils';
import userManager from './components/user-manager';

const apiUrl = "http://localhost:3001";
const getLogsEnd =  apiUrl + "/logRun";

const getItemsEnd =  apiUrl + "/itemsRun";
const createBoardEnd =  apiUrl + "/createBoard";
const getBoardTypesEnd =  apiUrl + "/boardTypes";

const getUserPreferencesEnd =  apiUrl + "/getUserPreferences";
const addFoodLogEnd =  apiUrl + "/addFoodLog";

const USER_ID = userManager.getUserId();

const optionHeaders = {
	'Accept': 'application/json',
	'Content-Type': 'application/json'
};

function apiCall(apiFunction, postData=[], callback={}) {
	const logs = false;
	const includeFns = false;
	if ( logs ) {
		if ( includeFns ) {
			console.log('APIHelper | apiCall | apiFunction', apiFunction , ' | postData ', postData);
		} else {
			console.log('APIHelper | apiCall | postData ', postData);
		}
	}
	
	
	if ( apiFunction && isAFunction(apiFunction) && isAFunction(callback) ) {
		apiFunction(postData,
			(res) => {
				if ( logs ) {
					console.log('APIHelper | apiCall | res', res);
				}
				callback(res);
			}
		)
	}
}

// export function getLogs(callback) {
// 	fetch(getLogsEnd)
// 		.then(res => res.json())
// 		.then(
// 			(result) => {
// 				// console.log(result);
// 				callback(result);
// 			},
// 		(error) => {
// 			console.log("error", error);
// 		}
// 	)
// 	// return false;
// }

// export function getItems(callback) {
// 	fetch(getItemsEnd)
// 		.then(res => res.json())
// 		.then(
// 			(result) => {
// 				// console.log(result);
// 				callback(result);
// 			},
// 		(error) => {
// 			console.log("error", error);
// 		}
// 	)
// 	// return false;
// }

// 
// Boards
// 

export function getBoards(callback) {
	var postData = {user_id: USER_ID};

	apiCall(apiManager.getBoardsData, postData, callback);
}

export function postCreateBoard(callback, details) {
	var opts = {
			user_id: USER_ID,
			details: details
	}

	var options = {
					method: 'post',
					headers: optionHeaders,
					body: JSON.stringify(opts)
	};

	fetch(createBoardEnd, options)
		.then(res => res.json())
		.then(
			(result) => {
				callback(result);
			},
		(error) => {
			console.log("error", error);
		}
	)
}

export function getBoardSettings(callback) {
	const postData = {
		user_id: USER_ID,
	};

	apiCall(apiManager.getBoardsSettings, postData, callback);
}

export function updateBoardVisibility(callback, postData={board_id: -1, hidden: true}) {
	apiCall(apiManager.updateBoardVisibility, postData, callback);
}

export function orderBoards(callback, postData={board_ids: []}) {
	const newPostData = {
		...postData,
		user_id: USER_ID
	};
	apiCall(apiManager.orderBoards, newPostData, callback);
}

export function getBoardTypes(callback) {
	const postData = {
		user_id: USER_ID,
	};

	apiCall(apiManager.getBoardTypes, postData, callback);
}

export function editBoard(callback, postData={board_id: -1, title: '' }) {
	apiCall(apiManager.editBoard, postData, callback);
}

export function newBoard(callback, postData={title: '', type_id: -1}) {
	const newPostData = {
		...postData,
		user_id: USER_ID
	};

	apiCall(apiManager.newBoard, newPostData, callback);
}

//
// Habits
//

export function getHabitDetails(callback, board_id) {
	var postData = {
		user_id: USER_ID,
		board_id: board_id
	};

	return apiCall(apiManager.getHabitsData, postData, callback);
}

export function habitUpdateStreak(callback, habit_id) {
	var postData = {
			habit_id: habit_id
	};
	apiCall(apiManager.updateHabitStreak, postData, callback);
}

export function newHabit(callback, 
						postData={
							board_id: -1, 
							title: '', 
							start_date: '2025-09-17', 
							duration_days: 27
						}) {
	
	const newPostData = {...postData, user_id: USER_ID};

	apiCall(apiManager.newHabit, newPostData, callback);
}

export function editHabit(callback,
						postData={
							habit_id: -1, 
							title: '', 
							start_date: '2025-09-17', 
							duration_days: 27
						}) {
	apiCall(apiManager.editHabit, postData, callback);
}

export function deleteHabit(callback, postData={habit_id: -1}) {
	apiCall(apiManager.deleteHabit, postData, callback);
}

// 
// Workouts
//

export function getWorkoutsData(callback, tracker_id) {
	const postData = {
		user_id: USER_ID,
		tracker_id: tracker_id
	}

	return apiCall(apiManager.getWorkoutsData, postData, callback);
}


export function markWorkoutAsDone(callback, workout_id) {
	var postData = {
		user_id: USER_ID,
		tracker_id: workout_id,
		workout_id: workout_id
	}

	apiCall(apiManager.markWorkoutDone, postData, callback);
}

export function restartWorkout(callback, workout_id) {
	const postData = {
		workout_id: workout_id
	}

	apiCall(apiManager.restartWorkout, postData, callback);
}

//
// ToDos
//

export function getTodosData(callback, board_id) {
	var postData = {
		board_id: board_id
	};

	return apiCall(apiManager.getToDosData, postData, callback);
}

export function createToDo(callback, postData={title: '', board_id: '', items: []}) {
	apiCall(apiManager.createToDo(postData, callback));
}

export function markTodoItemDone(callback, todo_id, done) {
	var postData = {
		todo_item_id: todo_id,
		done: done,
	}

	apiCall(apiManager.markToDoItemDone, postData, callback);
}

export function createToDoItem(callback, postData={content: '', dueDate: '', startDate: ''}) {
	apiCall(apiManager.newToDoItem(postData, callback));
}

export function editToDoItem(callback, postData={content: '', dueDate: '', startDate: ''}) {
	apiCall(apiManager.editToDoItem(postData, callback));
}

export function deleteToDoItem(callback, postData={id: -1}) {
	apiCall(apiManager.deleteToDoItem, postData, callback);
}

export function editTodo(callback, postData={todo_id: -1, title: ''}) {
	apiCall(apiManager.editToDo, postData, callback);
}

export function deleteToDo(callback, postData={todo_id: -1}) {
	apiCall(apiManager.deleteToDo, postData, callback);
}

export function orderToDos(callback, postData={board_id: -1, todo_ids: []}) {
	apiCall(apiManager.orderToDos, postData, callback);
}

//
// WLogs
//

export function getWlogs(callback, board_id=-1, offset=0) {
	var postData = {
		user_id: USER_ID,
		board_id: board_id,
		offset: offset
	};

	apiCall(apiManager.getWLogsData, postData, callback);
}

export function createWLog(callback, postData={value: '', board_id: -1}) {
	apiCall(apiManager.newWLog, postData, callback);
}

// 
// Notes
// 

export function getNotes(callback, board_id=-1) {
	const postData = {
		board_id: board_id
	};

	return apiCall(apiManager.getNotesData, postData, callback);
}

export function createNote(callback, postData={title: '', body: '', board_id: -1}) {
	apiCall(apiManager.newNote, postData, callback);
}

export function editNote(callback, postData={id: -1, title: '', body: '', board_id: -1}) {
	apiCall(apiManager.editNote, postData, callback);
}

export function deleteNote(callback, postData={id: -1}) {
	apiCall(apiManager.deleteNote, postData, callback);
}

// 
// Tasks
// 

export function getTasks(callback) {
	const postData = {
		user_id: USER_ID
	};

	return apiCall(apiManager.getTasks, postData, callback);
}

export function getTasksWeek(callback) {
	const postData = {
		user_id: USER_ID
	};

	apiCall(apiManager.getTasksWeek, postData, callback);
}

export function getTasksTargetWeek(callback, postData={user_id: -1, target_date: '2025-09-19'}) {
	postData.user_id = USER_ID;

	apiCall(apiManager.getTasksTargetWeek, postData, callback);
}

export function getTasksTargetDate(callback, postData={user_id: -1, target_date: '2025-09-19'}) {
	postData.user_id = USER_ID;

	apiCall(apiManager.getTasksTargetDay, postData, callback);
}

// 
// Budget
// 

export function getBudget(callback, postData={board_id:-1, offset:0, date_start: '2026-08-01', date_end: '2026-08-31'}) {
	return apiCall(apiManager.getBudget, postData, callback);
}

export function createSpending(callback, postData={value: '', board_id: -1}) {
	apiCall(apiManager.newSpending, postData, callback);
}

export function deleteSpending(callback, postData={id: -1}) {
	apiCall(apiManager.deleteSpending, postData, callback);
}

export function getLogBoardSettings(callback, postData={ board_id: -1 }) {
	apiCall(apiManager.getLogBoardSettings, postData, callback);
}

export function editLogBoardSettings(callback, postData={ id: -1, unit: '', unitSuffix: false, shouldTally: false, tally: -1 }) {
	apiCall(apiManager.editLogboardSettings, postData, callback);
}

//
// User
//

export function loginUser(callback, postData={username:'', password:'' }) {
	apiCall(apiManager.login, postData, callback);
}

export function getUserPreferences(callback) {
	var opts = {user_id: USER_ID};

	var options = {
				  	method: 'post',
					headers: optionHeaders,
					body: JSON.stringify(opts)
	};

	fetch(getUserPreferencesEnd, options)
		.then(res => res.json())
		.then(
			(result) => {
				// console.log(result);
				callback(result);
			},
		(error) => {
			console.log("error", error);
		}
	)
}

export function addFoodLog(callback, opts) {
	// var opts2 = {foodLog: "here"};
	
	fetch(addFoodLogEnd, {
		method: 'POST',
		body: JSON.stringify(opts)
	})
		.then(res => res.json())
		.then(
			(result) => {
				// console.log(result);
				callback(result);
			},
		(error) => {
			console.log("error", error);
		}
	)
}

export function apiResultSuccess(result) {
	if ( result && result.success && result.success === true ) {
		return true;
	}
	return false;
} 

export function textNotEmpty(text) {
	if ( text == undefined || text == "" ) {
		return false;
	}
	return true;
}